interface ScriptTextProps {
  children: React.ReactNode;
  className?: string;
  as?: "span" | "p" | "h2" | "h3" | "div";
}

export default function ScriptText({
  children,
  className = "",
  as: Tag = "span",
}: ScriptTextProps) {
  return (
    <Tag
      className={`font-script leading-tight text-faded-terracotta ${className}`}
    >
      {children}
    </Tag>
  );
}
